import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthorizationService, UserService } from '@mirage-projects/cw-commons';

import { AppSharedService } from './app-shared.service';
import { CWEnvironmentConfiguration } from './core/services/environment-configuration';
import { EnvironmentConfigurationService } from './core/services/environment-configuration.service';

/** This is the root component for Site application */
@Component({
    selector: 'cw-root',
    templateUrl: './app-site.component.html',
    standalone: false,
})
export class AppSiteComponent implements OnInit {
    private environmentConfig: CWEnvironmentConfiguration = this.envConfigService.getAppConfig();

    constructor(
        private userService: UserService,
        private authorizationService: AuthorizationService,
        private router: Router,
        private envConfigService: EnvironmentConfigurationService,
        private changeDetectorRef: ChangeDetectorRef,
        public appSharedService: AppSharedService
    ) {}

    ngOnInit(): void {
        if (location.pathname === '/logout') {
            this.authorizationService.appLogout();
        }
        this.appSharedService.init(this.changeDetectorRef);
        this.loginForSite();
    }

    get showContent(): boolean {
        return this.appSharedService.isUserLogged;
    }

    private loginForSite(): void {
        const user = this.environmentConfig.userSite;
        const password = this.environmentConfig.pwSite;
        this.authorizationService.loginCRE(user, password).subscribe((tokenResponse) => {
            this.authorizationService.setToken(tokenResponse.token);
            this.userService.get(user).subscribe((userData) => {
                const user = this.authorizationService.userResponseToUser(userData);
                this.authorizationService.setCurrentUser(user);
                this.appSharedService.setUserLogged(user);

                if (!tokenResponse.alreadyLoged) {
                    this.navigateToMainPage();
                }
            });
        });
    }

    /**
     * When user is logged for SITE it avigates to projects page
     */
    private navigateToMainPage(): void {
        this.router.navigate(['/', 'projects']);
    }
}
